import { useEffect, useState } from 'react';
import { Platform } from 'react-native';
import { businessApi } from '@/lib/api/business';

// Public pages describe Business as available only when the server says
// enrollment is genuinely open. Any failure, or a partial rollout such as a
// pilot allowlist, reads as "soon": the pages must never overstate availability.
let settled = null;
let inflight = null;

export function readBusinessEnrollment(api = businessApi) {
  if (settled) return Promise.resolve(settled);
  inflight ||= api.catalog()
    .then(catalog => (settled = catalog?.enrollmentAvailable === true ? 'open' : 'soon'))
    .catch(() => 'soon')
    .finally(() => { inflight = null; });
  return inflight;
}

export function resetBusinessEnrollment() { settled = null; inflight = null; }

// 'loading' | 'open' | 'soon'
export default function useBusinessEnrollment() {
  const [state, setState] = useState(settled || 'loading');
  useEffect(() => {
    if (Platform.OS !== 'web') return undefined;
    let live = true;
    readBusinessEnrollment().then(value => { if (live) setState(value); });
    return () => { live = false; };
  }, []);
  return state;
}
